import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractObjectUpdateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimUpdateWorkOrderChangeObjectGql } from '../bimWorkOrderChangeStructureQueries';

const requestId = 'bimUpdateWorkOrderObjectChange';

export const useBimUpdateWorkOrderObjectChange = (workOrderChangeId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [bimUpdateWorkOrderObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        bimUpdateWorkOrderObjectReset(undefined);
        onSuccess?.();
    }, [bimUpdateWorkOrderObjectReset, onSuccess]);

    const [
        bimUpdateWorkOrderChangeObjectData,
        bimUpdateWorkOrderChangeObjectStatus,
        bimUpdateWorkOrderChangeObjectError,
        bimUpdateWorkOrderChangeObjectRequest,
    ] = useRequest({
        requestId,
        query: bimUpdateWorkOrderChangeObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const bimUpdateWorkOrderObjectChangeMakeRequest = useCallback(
        (input: BimContractObjectUpdateInput) => {
            dispatch(bimUpdateWorkOrderChangeObjectRequest({ workOrderChangeId, input }));
        },
        [bimUpdateWorkOrderChangeObjectRequest, dispatch, workOrderChangeId],
    );

    useEffect(() => {
        bimUpdateWorkOrderObjectReset(undefined);
    }, [bimUpdateWorkOrderObjectReset]);

    return {
        bimUpdateWorkOrderChangeObjectData,
        bimUpdateWorkOrderChangeObjectStatus,
        bimUpdateWorkOrderChangeObjectError,
        bimUpdateWorkOrderObjectChangeMakeRequest,
    };
};
